var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 3.72386 0.223858 3.5 0.5 3.5H6.29289L4.14645 1.35355C3.95118 1.15829 3.95118 0.841708 4.14645 0.646446C4.34171 0.451184 4.65829 0.451184 4.85355 0.646446L7.85355 3.64645C8.04882 3.84171 8.04882 4.15829 7.85355 4.35355L4.85355 7.35355C4.65829 7.54882 4.34171 7.54882 4.14645 7.35355C3.95118 7.15829 3.95118 6.84171 4.14645 6.64645L6.29289 4.5H0.5C0.223858 4.5 0 4.27614 0 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.f9b4151df040b11490527cb6915cefd6.svg";
export { ForwardRef as ReactComponent };